export default __webpack_public_path__ + "static/media/default_league_photo.ad668e3c.jpeg";